import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.number.constructor.js";
import SvgIcon from '@/components/svg-icon';
export default {
  components: {
    SvgIcon: SvgIcon
  },
  props: {
    type: {
      type: Number,
      default: 1,
      validator: function validator(value) {
        return [1, 2, 3].includes(value);
      }
    },
    iconName: {
      type: String,
      default: 'loading'
    },
    size: {
      type: Number,
      default: 14
    },
    animation: {
      // 动作动画
      type: Boolean,
      default: false
    }
  },
  computed: {
    loadingClass: function loadingClass() {
      if (this.animation) {
        return "searching-animation-".concat(this.type);
      } else {
        return 'searching-animation-1';
      }
    }
  }
};